import { z } from 'zod';

export const completeClipUploadRequestSchema = z.object({
  apiUrl: z.string(),
  clipId: z.number(),
  path: z.string(),
});

export type ICompleteClipUploadRequest = z.infer<typeof completeClipUploadRequestSchema>;
